function isPaymeLocaleVisible() {
  const lang = document.documentElement.lang?.slice(0, 2)?.toLowerCase();
  return lang === 'uz';
}

function paymeConfig() {
  const body = document.body;
  if (!body || body.dataset.paymeEnabled !== 'true') return null;
  if (!isPaymeLocaleVisible()) return null;
  const base = (body.dataset.paymentApiBase || '').replace(/\/$/, '');
  if (!base) return null;
  return {
    base,
    resultPath: body.dataset.paymentResultPath || '/pages/about?view=payment-result',
  };
}

function submitPaymeForm(payme) {
  if (!payme?.action || !payme?.fields) throw new Error('Invalid Payme form payload');
  const form = document.createElement('form');
  form.method = payme.method || 'POST';
  form.action = payme.action;
  form.acceptCharset = 'UTF-8';
  Object.entries(payme.fields).forEach(([name, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = String(value ?? '');
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
}

async function startPaymeCheckout(button) {
  const cfg = paymeConfig();
  if (!cfg) return;

  const loadingText = button.getAttribute('data-payme-loading-text') || '…';
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = loadingText;

  const errorEl = document.querySelector('[data-payme-error]');

  try {
    const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!cartRes.ok) throw new Error('Cart unavailable');
    const cart = await cartRes.json();
    if (!cart?.item_count) throw new Error('Cart is empty');

    const returnUrl = new URL(cfg.resultPath, window.location.origin).href;
    const locale = document.documentElement.lang?.slice(0, 2) || 'ru';

    const res = await fetch(`${cfg.base}/api/checkout`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ cart, return_url: returnUrl, lang: locale }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.ok) {
      throw new Error(data.error || `Checkout failed (${res.status})`);
    }

    submitPaymeForm(data.payme);
  } catch (err) {
    button.disabled = false;
    button.textContent = originalText;
    if (errorEl) {
      errorEl.textContent = err.message || 'Payment error';
      errorEl.hidden = false;
    } else {
      window.alert(err.message || 'Payment error');
    }
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-payme-checkout]');
  if (!button || button.disabled) return;
  event.preventDefault();
  void startPaymeCheckout(button);
});
